import { oc } from '@orpc/contract';
import { steeringReportInputSchema, steeringReportOutputSchema } from '../schemas/reports.schemas.js';
/**
 * A read, sent as POST because its input is a nested `period` union and a KPI id list, which a query string carries
 * poorly.
 */
export const getSteeringReportContract = oc
    .route({
    method: 'POST',
    path: '/reports/steering',
    tags: ['Reports'],
    summary: 'The weekly steering report for a period, scoped to the pillars the caller may see (read-only)',
})
    .input(steeringReportInputSchema)
    .output(steeringReportOutputSchema);
//# sourceMappingURL=get-steering-report.contract.js.map